export default __webpack_public_path__ + "assets/images/13b1731c9026fec35b262a25b88a8fc1.png";